export const formatTimeInMinutes = (timeString: string): string => {
  const messageTime = new Date(timeString);
  const minutesAgo = Math.floor(
    (new Date().getTime() - messageTime.getTime()) / (60 * 1000)
  );

  return `${minutesAgo} minutes ago (${messageTime.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "numeric",
  })})`;
};
